/* eslint-disable @stylistic/brace-style */
import { optionsProxy } from '@vlabs/uikit';
import i18n from 'i18next';

export const OBJECTS_TYPE = optionsProxy.create([
  { value: 'events', get label() { return i18n.t('lunaTasks:enums.objects_type.events'); } },
  { value: 'faces', get label() { return i18n.t('lunaTasks:enums.objects_type.faces'); } },
]);

export const TARGET = optionsProxy.create([
  { value: 'events', get label() { return i18n.t('lunaTasks:enums.target.events'); } },
  { value: 'event_descriptors', get label() { return i18n.t('lunaTasks:enums.target.event_descriptors'); } },
  { value: 'faces', get label() { return i18n.t('lunaTasks:enums.target.faces'); } },
  { value: 'face_descriptors', get label() { return i18n.t('lunaTasks:enums.target.face_descriptors'); } },
  { value: 'general_events', get label() { return i18n.t('lunaTasks:enums.target.general_events'); } },
]);

export const DESCRIPTOR_TYPE = optionsProxy.create([
  { value: 'face', get label() { return i18n.t('lunaTasks:enums.descriptor_type.face'); } },
  { value: 'body', get label() { return i18n.t('lunaTasks:enums.descriptor_type.body'); } },
]);

export const EXTRACTION_TARGET = optionsProxy.create([
  { value: 'basic_attributes', get label() { return i18n.t('lunaTasks:enums.extraction_target.basic_attributes'); } },
  { value: 'face_descriptor', get label() { return i18n.t('lunaTasks:enums.extraction_target.face_descriptor'); } },
  { value: 'body_descriptor', get label() { return i18n.t('lunaTasks:enums.extraction_target.body_descriptor'); } },
]);

export const MATCH_TYPE = optionsProxy.create([
  { value: 'faces', get label() { return i18n.t('lunaTasks:enums.objects_type.faces'); } },
  { value: 'events', get label() { return i18n.t('lunaTasks:enums.objects_type.events'); } },
  { value: 'attributes', get label() { return i18n.t('lunaTasks:enums.objects_type.attributes'); } },
]);

export const TASK_TYPE = optionsProxy.create([
  { value: 0, get label() { return i18n.t('lunaTasks:enums.task_type.0'); } },
  { value: 1, get label() { return i18n.t('lunaTasks:enums.task_type.1'); } },
  { value: 2, get label() { return i18n.t('lunaTasks:enums.task_type.2'); } },
  { value: 3, get label() { return i18n.t('lunaTasks:enums.task_type.3'); } },
  { value: 4, get label() { return i18n.t('lunaTasks:enums.task_type.4'); } },
  { value: 5, get label() { return i18n.t('lunaTasks:enums.task_type.5'); } },
  { value: 6, get label() { return i18n.t('lunaTasks:enums.task_type.6'); } },
  { value: 7, get label() { return i18n.t('lunaTasks:enums.task_type.7'); } },
  { value: 8, get label() { return i18n.t('lunaTasks:enums.task_type.8'); } },
  { value: 9, get label() { return i18n.t('lunaTasks:enums.task_type.9'); } },
]);

export const TASK_STATUS = optionsProxy.create([
  { value: 0, get label() { return i18n.t('lunaTasks:enums.task_status.0'); } },
  { value: 1, get label() { return i18n.t('lunaTasks:enums.task_status.1'); } },
  { value: 2, get label() { return i18n.t('lunaTasks:enums.task_status.2'); } },
  { value: 3, get label() { return i18n.t('lunaTasks:enums.task_status.3'); } },
  { value: 4, get label() { return i18n.t('lunaTasks:enums.task_status.4'); } },
  { value: 5, get label() { return i18n.t('lunaTasks:enums.task_status.5'); } },
]);

export const SCHEDULE_CRON_TIMEZONE = optionsProxy.create([
  { value: 'local', get label() { return i18n.t('lunaTasks:enums.cron_timezone.local'); } },
  { value: 'utc', get label() { return i18n.t('lunaTasks:enums.cron_timezone.utc'); } },
]);
export const EVENT_TYPES = optionsProxy.create([
  { value: 'crowd', get label() { return i18n.t('lunaTasks:enums.event_type.crowd'); } },
  { value: 'human_tracking', get label() { return i18n.t('lunaTasks:enums.event_type.human_tracking'); } },
  { value: 'fight', get label() { return i18n.t('lunaTasks:enums.event_type.fight'); } },
  { value: 'weapon', get label() { return i18n.t('lunaTasks:enums.event_type.weapon'); } },
  { value: 'fire', get label() { return i18n.t('lunaTasks:enums.event_type.fire'); } },
]);

export const SCHEDULE_STATUS = optionsProxy.create([
  { value: 'running', get label() { return i18n.t('lunaTasks:enums.schedule_status.running'); } },
  { value: 'stopped', get label() { return i18n.t('lunaTasks:enums.schedule_status.stopped'); } },
]);

export const LUNA_TASK_ENUMS = {
  MATCH_TYPE,
  OBJECTS_TYPE,
  TARGET,
  TASK_TYPE,
  DESCRIPTOR_TYPE,
  EXTRACTION_TARGET,
  TASK_STATUS,
  SCHEDULE_CRON_TIMEZONE,
  SCHEDULE_STATUS,
  EVENT_TYPES,
};
